//tipos
import { GetterTree } from "vuex";
import {
  Servicio,
  Servicios,
} from "@/typings/store/plugins/easyFirestore/servicios";
import { State } from "@/typings/store/index";

interface ServiciosState {
  all: Servicios;
}

const getters: GetterTree<ServiciosState, State> = {
  get(state, getters) {
    return (getters["getArray"] as Array<Servicio>).reduce((docs, doc) => {
      if (!doc?.id) {
        console.error("doc.id == undefined => ", doc);
        return docs;
      }
      docs[doc.id] = doc;
      return docs;
    }, {} as Servicios);
  },
  getArray(state) {
    return Object.values(state.all)
      .map((doc) => {
        return JSON.parse(JSON.stringify(doc)) as Servicio;
      })
      .sort((a, b) => {
        return a.nombre.localeCompare(b.nombre);
      });
  },
};

const servicios = {
  firestorePath: "{env}/v1/empresas/{idEmpresa}/servicios",
  firestoreRefType: "collection",
  moduleName: "servicios",
  statePropName: "all",
  namespaced: true,

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default servicios;
